import { render, staticRenderFns } from "./product-browser.vue?vue&type=template&id=4f1b9548&"
import script from "./product-browser.vue?vue&type=script&lang=js&"
export * from "./product-browser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports